exports.constants = {
  PLAYLIST_TRANSITION_DURATION: 300,
  'DEBUG_STYLE_1' : 'background-color: #aaa022; color: #222222;',
  'DEBUG_STYLE_2' : 'background-color: #7c3b8e; color: #ffffff;',
  'DEBUG_STYLE_3' : 'background-color: #3a696b; color: #eeeeee;',
  'DEBUG_STYLE_ERROR' : 'background-color: #3a696b; color: #eeeeee;',
  URL_WAVESURFER : 'https://unpkg.com/wavesurfer.js@3.3.3/dist/wavesurfer.min.js',
  WAVESURFER_MAX_TIMEOUT : 20000,
  URL_JQUERY : 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js',
  DEBUG_STYLE_PLAY_FUNCTIONS: 'background-color: #daffda; color: #222222;',
  ERRORED_OUT_CLASS: 'errored-out',
  ERRORED_OUT_MAX_ATTEMPTS: 5
}
